import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=6a2d2090&scoped=true"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"
import style0 from "./TableView.vue?vue&type=style&index=0&id=6a2d2090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d2090",
  null
  
)

export default component.exports